import { reducer } from "./reducer"
export const StockLocationReducer = reducer

export * from "./types"



// WEBPACK FOOTER //
// ./src/state/inventory/location/reducers/index.ts